import { render, staticRenderFns } from "./NullAttachments.vue?vue&type=template&id=c0d936e0&"
import script from "./NullAttachments.vue?vue&type=script&lang=js&"
export * from "./NullAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports